import React from 'react'

// icons
import CloudCircle from '@mui/icons-material/CloudCircle'

import styled from 'styled-components'

// theme
import aampeTheme from '../../constants/aampeTheme'

export default function LoadingError({
    errorMsg = "We're having some connection issues",
}) {
    return (
        <Container>
            <CloudCircle style={{ fontSize: '100px' }} color="secondary" />
            <Body>
                {typeof errorMsg === 'string'
                    ? errorMsg
                    : "We're having some connection issues"}
            </Body>
        </Container>
    )
}

const Container = styled.div({
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    width: '100%',
    height: '70vh',
    backgroundColor: aampeTheme.colors.primary50,
})

const Body = styled.div({
    fontsize: '20px',
    marginLeft: aampeTheme.spacing4(2),
})
